__turbopack_context__.v({
  "fadeInOut": "LoadingState-module__LJ870q__fadeInOut",
  "floatUpDown": "LoadingState-module__LJ870q__floatUpDown",
  "loaderContainer": "LoadingState-module__LJ870q__loaderContainer",
  "messageContainer": "LoadingState-module__LJ870q__messageContainer",
  "secondaryMessage": "LoadingState-module__LJ870q__secondaryMessage",
});
